import React, { useState } from "react";
import { Box, Divider, Tab, Tabs, Grid, Stack } from "@mui/material";
import SwipeableViews from "react-swipeable-views";
import Overview_1 from "utils/components/analytics-overview";
import Overview_2 from "utils/components/analytics-separated-by-unit";
import Overview_3 from "utils/components/analytics-yearly-comparison-overview";
import Overview_4 from "utils/components/analytics-yearly-comparison-separated-units";
import Overview_5 from "utils/components/analysis-comparative-disease-group";

// TabPanel Component
function TabPanel({ children, value, index }) {
    return (
        <div role="tabpanel" hidden={value !== index}>
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function HealthSummaryDashboard() {
    const [value, setValue] = useState(0);

    return (
        <>
            <Box sx={{ display: "grid", gridGap: "10px" }}>
                <Box sx={{ color: "#478F96", fontWeight: 600 }}>แดชบอร์ดสรุปสุขภาพ</Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        padding: '0 5px'
                    }}
                >
                    <Tabs
                        value={value}
                        onChange={(event, newValue) => setValue(newValue)}
                        sx={{ p: "0px 5px" }}
                    >
                        <Tab label="ภาพรวม สป." sx={{
                            fontWeight: 'bold',
                            // backgroundColor: (theme) => theme.palette.primary.main,
                            color: '#478F96',
                            '&.Mui-selected': {
                                backgroundColor: '#A3D5D5', // Change color when selected
                                color: '#006D6D', // Change text color when selected
                            },
                        }} />
                        <Tab label="แยกรายหน่วย" sx={{
                            fontWeight: 'bold',
                            // backgroundColor: (theme) => theme.palette.primary.main,
                            color: '#478F96',
                            '&.Mui-selected': {
                                backgroundColor: '#A3D5D5', // Change color when selected
                                color: '#006D6D', // Change text color when selected
                            },
                        }} />
                        <Tab label="เปรียบเทียบรายปี ภาพรวม สป." sx={{
                            fontWeight: 'bold',
                            // backgroundColor: (theme) => theme.palette.primary.main,
                            color: '#478F96',
                            '&.Mui-selected': {
                                backgroundColor: '#A3D5D5', // Change color when selected
                                color: '#006D6D', // Change text color when selected
                            },
                        }} />
                        <Tab label="เปรียบเทียบรายปี แยกหน่วย" sx={{
                            fontWeight: 'bold',
                            // backgroundColor: (theme) => theme.palette.primary.main,
                            color: '#478F96',
                            '&.Mui-selected': {
                                backgroundColor: '#A3D5D5', // Change color when selected
                                color: '#006D6D', // Change text color when selected
                            },
                        }} />
                        <Tab label="เปรียบเทียบตามกลุ่มโรค" sx={{
                            fontWeight: 'bold',
                            // backgroundColor: (theme) => theme.palette.primary.main,
                            color: '#478F96',
                            '&.Mui-selected': {
                                backgroundColor: '#A3D5D5', // Change color when selected
                                color: '#006D6D', // Change text color when selected
                            },
                        }} />
                    </Tabs>
                    <Divider />
                    <SwipeableViews
                        index={value}
                        onChangeIndex={(index) => setValue(index)}
                    >
                        <TabPanel value={value} index={0}>
                            <Overview_1 />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <Overview_2 />
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <Overview_3 />
                        </TabPanel>
                        <TabPanel value={value} index={3}>
                            <Overview_4 />
                        </TabPanel>
                        <TabPanel value={value} index={4}>
                            <Overview_5/>
                        </TabPanel>
                    </SwipeableViews>
                </Box>
            </Box>
        </>
    );
}

export default HealthSummaryDashboard;
